module.exports = __webpack_public_path__ + "static/media/applogo.448ea017.png";